/**
 * Bundle upsell add-to-cart.
 *
 * The bundle form posts several `items[]` lines at once, so it can't go through
 * <product-form> (that one assumes a single `[name=id]` input and a loading
 * spinner). This mirrors its behaviour instead: POST to /cart/add, then hand the
 * response to the cart drawer/notification so it renders and opens, rather than
 * letting the browser follow the native redirect to /cart.
 *
 * Used by both 'bundle_upsell' and 'bundle_upsell__simple'.
 */
if (!customElements.get('bundle-upsell')) {
  customElements.define(
    'bundle-upsell',
    class BundleUpsell extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.submitButton = this.querySelector('[type="submit"]');
        this.errorTarget = this.querySelector('[data-bundle-upsell-error]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (this.cart && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(event) {
        // No drawer or notification on the page: leave the native POST alone so
        // the browser still adds the items and lands on the cart page.
        if (!this.cart) return;

        event.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.setError();
        this.setLoading(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'bundle-upsell',
                errors: response.description,
                message: response.message,
              });
              this.setError(response.description || response.message);
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-upsell' });
            this.cart.classList.remove('is-empty');
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.setError(this.dataset.errorMessage);
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;

        this.submitButton.classList.toggle('loading', isLoading);
        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', true);
        } else {
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      setError(message = '') {
        if (!this.errorTarget) return;

        this.errorTarget.textContent = message;
        this.errorTarget.toggleAttribute('hidden', !message);
      }
    }
  );
}
